import {
  Checkbox,
  KoActivityTypes,
  KoBadge,
  KoButton,
  KoDate,
  KoDateFormatter,
  KoForm,
  KoFormBuilder,
  KoLoader,
  KoModal,
  KoNano,
  KoRichTextEditor,
  KoSelect,
  KoTabs,
  KoTag,
  KoText,
  KoTitle,
  KoToast,
  KoTooltips,
  KoUpload,
  KoUserSelect
} from "packages";
import styles from "./curd.module.scss";
import { getCookie } from 'shared/utils/cookies';
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {AssetsAPI }from '../assets.service';
import { useParams } from "react-router";
import { PRIORITY } from 'shared/commonConstants';
import { useDispatch } from "react-redux";
import { resetState } from 'shared/store/tickettabCountSlice';
import dayjs from 'dayjs';
import {  convertToAmPm, getCommonAvailableTimeBlocks } from 'shared/utils';
import SubTasksTable from "../../curd/subtasks";
import WorkLog from "../../curd/workLog";
import Comments from "pages/drive/comments";
import Attachemnts from "../../curd/attachemnts";
import KoIcon from "@kwapio/icons";
import {getTicketTabCount } from "shared/store/slice";
import { getCurrentAssignees } from 'shared/store/currentAssigneesSlice';
import { TimeSpent } from 'shared/components';

function Assets({ form,  getIssueById, handleFinish, initialValues,epic ,subtask,epicId}) {
  const { workspaceId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const modules = useSelector(state => state?.modules);
  const dispatch = useDispatch();
  const [moduleList, setModuleList] = useState(modules?.["data"] || []);
  const isCalendar = KoForm.useWatch("isCalendar", form) || false;
  const [activityTypes, setActivityTypes] = useState(undefined);
  const [currentWorkspaceId, setCurrentWorkspaceId] = useState(workspaceId);
  const currentAssignees = useSelector(state => state?.currentAssignees);
  const profile = currentAssignees['data'] || [];
  const [customersList, setDataList] = useState();
  const endDatePicker = KoForm.useWatch('endDate', form);
  const startDatePicker = KoForm.useWatch('startDate', form);
  const [filteredSlots, setFilteredSlots] = useState([]);
  const durationSelected = KoForm.useWatch('duration', form);
  const [allslots, setAllSlots] = useState([]);
  const [specList, setSpecList] = useState();
  const releases = useSelector(state => state?.releases);
  const [releaseList, setReleaseList] = useState(releases?.['data'] || []);
  const [componentsList, setComponentsList] = useState();
  const [lookupId, setLookupId] = useState();
  const ticketTabCount = useSelector(state => state?.ticketTabCount);
  const [issueStates, setIssueStates] = useState(ticketTabCount['data']);
  const [uploadFileModal, setUploadFileModal] = useState(false);
  const [attachementsList , setAttachementsList] = useState([]);
  const [ticketStates, setTicketStates] = useState();
  const [refresh, setRefresh] = useState(false);
  const [createSubTask, setCreateSubTask] = useState();
  const [workspace, setWorkspaceRecord] = useState();
  const [isOpenCommentsModal, setCreateComment] = useState();
  const [isCreateLogOpen, setCreateLog] = useState();
  const getWorkFlow = (ticketId, wosId) => {
    let q={
      id:ticketId
    };
    AssetsAPI.getWorkFlowStatus(ticketId ? q : {}, wosId).then(
      (data) => {
        setTicketStates(data['status']);
      },
      (err) => {
      }
    );
  };

  useEffect(() => {
    getWorkspaceById(currentWorkspaceId);
    if (currentAssignees['data'].length === 0) {
      dispatch(getCurrentAssignees(workspaceId));
    }
  }, [currentWorkspaceId]);
  const getWorkspaceById = (workspaceId) => {
    if (!workspaceId) {
      return;
    }
    AssetsAPI.getWorkspaceById(workspaceId).then(
      (data) => {
        setWorkspaceRecord(data['project']);
      },
      (err) => {
      }
    );
  
  };
    
  useEffect(() => {
    getWorkFlow(initialValues?.ticketId, initialValues?.workspace || currentWorkspaceId);
    if(initialValues?.ticketId){
      AssetsAPI.getAttachments(initialValues?.ticketId, workspaceId).then(
        (data) => {
          setLoading(false);
          setAttachementsList(data['attachments']);
        },
        (err) => {
          setLoading(false);
          console.log(err);
        }
      );
    }
      
  }, [initialValues?.ticketId]);
    
  useEffect(() => {
    setIssueStates(ticketTabCount['data']);
  }, [ticketTabCount]);
  const getComponents = () => {
    setComponentsList();
    AssetsAPI.getComponents(null, currentWorkspaceId).then(
      (data) => {
        setComponentsList(data?.components);
      },
      (err) => {
      }
    );
  };
  useEffect(() => {
    if (currentWorkspaceId) {
      getComponents();
    }
  }, []);
    
  useEffect(() => {
    if (releases?.['data']) {
      setReleaseList(releases['data']);
    }
  }, [releases?.['data']]);
  
  useEffect(() => {
    if (startDatePicker && endDatePicker) {
      setAllSlots([]);
  
      let q={
        startDate: dayjs(startDatePicker).format('YYYY-MM-DD'),
        endDate:dayjs(endDatePicker).format('YYYY-MM-DD')
      };
      AssetsAPI.availableSlots(q).then(
        (data) => {
          let availableSlots = data['availableSlots'];
          const result = getCommonAvailableTimeBlocks(availableSlots);
          console.log('startDatePicker', result);
          setAllSlots(result);
        },
        (err) => {
        }
      );
      
    }
  }, [startDatePicker, endDatePicker]);

  useEffect(() => {
    if (durationSelected) {
      const timeSlots = allslots.filter(slot => {
        const parts = slot.label.split(' - ');
        const durationPart = parts[1] || ''; // safe check
        return durationPart === durationSelected;
      });
  
      const formattedData = timeSlots.map(item => {
        const parts = item.value.split('-');
        const startTime = parts[0] ? convertToAmPm(parts[0]) : '';
        const endTime = parts[1] ? convertToAmPm(parts[1]) : '';
        const newLabel = `${startTime} - ${endTime}`;
  
        return {
          label: newLabel,
          value: item.value
        };
      });
      setFilteredSlots(formattedData);
    } else {
      setFilteredSlots([]);
    }
  }, [durationSelected, allslots]);
    
  useEffect(() => {
    getSpecList(pagination);
    getClients(pagination);
    return () => {
      dispatch(resetState());
    };
  }, []);

  useEffect(() => {
    if (currentWorkspaceId) {
      setActivityTypes(undefined);
      AssetsAPI.getActivityTypes(currentWorkspaceId).then(
        (data) => {
          setActivityTypes(data?.activities || []);
        },
        () => {
          setActivityTypes([]);
        }
      );
    }
  }, [currentWorkspaceId]);

  useEffect(() => {
    if (initialValues?.workspace) {
      setCurrentWorkspaceId(initialValues?.workspace);
    }
  }, [initialValues?.workspace]);
  const getSpecList = (searchText) => {
    AssetsAPI.getDocuments(pagination, null, currentWorkspaceId).then(
      (data) => {
        setSpecList(data?.files);
      },
      (err) => {
      }
    );
  };

  const [pagination] = useState({
    size: 10000,
    offset: 0,
    page: 1
  });
  useEffect(() => {
    getClients();
  }, []);

  const getClients = () => {
    setLoading(true);
    AssetsAPI.getClients().then(
      (data) => {
        setLoading(false);
        setDataList(data['customers']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  const Date = ({ value, onChange }) => {
    return (
      <KoDate
        value={value}
        format={"DD-MMM-YYYY"}
        daysAgo={0}
        onChange={(v) => onChange(v)}
      />
    );
  };

  const IssueType = ({ value, onChange }) => (
    <KoActivityTypes value={epic ? 1 : value}
      options={activityTypes}
      onChange={v => onChange(v)} initialValues={initialValues} subtask={subtask} epic={epic} />
     
  );

  const TaskStatus = ({ value, onChange }) => (
    <KoSelect
      value={ticketStates?.length > 0 ? value :''}
      showSearch
      defaultValue={ticketStates?.length > 0 ? ticketStates[0].value : ''}
      onChange={v => onChange(v)}
      placeholder='Select status'
      options={ticketStates}
      optionRender={(option) => {
        const label = option?.data?.label;
        const formattedLabel = typeof label === 'string' ? label.replace(" ", '') : '';
        return (
          <div className={styles.statusWrapper} >
            <div style={{borderColor: option?.data?.color}} className={`${styles.status} ${styles[formattedLabel]}`} role="img" aria-label={label} />
            <KoText text={label} />
          </div>
        );
      }}
    />
  );

  const Priority = ({ value, onChange }) =>
    <KoSelect value={value}
      showSearch
      defaultValue={3}
      onChange={v => onChange(v)}
      placeholder='Select priority'
      options={PRIORITY}
      optionRender={(option) => (
        <div className={styles.priorityWrapper}>
          <span>{option.data.label}</span>
        </div>
      )}
    />;

  const Category = ({ value, onChange }) =>
    <KoSelect
      placeholder="Select Category"
      value={value}
      onChange={v => onChange(v)}
      options={[{
        name:'USD', value:'usd'
      }].map((module) => ({
        label: module?.name,
        value: module?.value
      }))}
    />;
  const Assignees = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} users={profile} placeholder='Select assignee' />;

  const Reporter = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} users={profile} placeholder='Select reporter' />;

  const Customers = ({ value, onChange }) =>
    <KoSelect
      value={value}
      showSearch
      mode="multiple"
      optionFilterProp="label"
      placeholder="Select customer"
      onChange={onChange}
      options={customersList?.map(cus => ({
        label: cus?.companyName || 'Unnamed Customer',
        value: cus?.customerId
      }))}
      loading={!customersList?.length}
    />;

  const CheckBox = ({ value, onChange }) =>
    <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>{`Include in Calendar`}</Checkbox>;

  const Duration = ({ value, onChange }) => {
    return (
      <KoSelect
        value={value}
        onChange={v => onChange(v)}
        showSearch
        allowClear
        placeholder='Choose duration'
        options={DurationValues?.map((value) => ({
          label: value.label,
          value: value?.value
        }))}
      />
    );
  };

  const StarTime = ({ value, onChange }) => {
    return (
      <KoSelect
        value={value}
        onChange={onChange}
        showSearch
        allowClear
        disabled={!endDatePicker || !startDatePicker}
        filterOption={(input, option) => {
          return option?.label?.toLowerCase().slice(0, 12).includes(input.toLowerCase());
        }}
        placeholder="Choose Time Slot"
        options={filteredSlots}
      />
    );
  };

  const DurationValues = [
    { label: "15 Mins", value: "15m" },
    { label: "30 Mins", value: "30m" },
    { label: "45 Mins", value: "45m" },
    { label: "1 Hour", value: "1h" },
    { label: "1.5 Hour", value: "1.5h" },
    { label: "2 Hour", value: "2h" },
    { label: "2.5 Hour", value: "2.5h" },
    { label: "3 Hour", value: "3h" },
    { label: "3.5 Hour", value: "3.5h" },
    { label: "4 Hour", value: "4h" },
    { label: "4.5 Hour", value: "4.5h" },
    { label: "5 Hour", value: "5h" },
    { label: "5.5 Hour", value: "5.5h" },
    { label: "6 Hour", value: "6h" },
    { label: "6.5 Hour", value: "6.5h" }
  ];
  const Watchers = ({ value, onChange }) =>
    <KoUserSelect mode='multiple' value={value} onChange={v => onChange(v)} users={profile} placeholder='Select watchers' />;

  const SpecLink = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      mode='multiple'
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      // onSearch={debounceFetcher}
      allowClear
      placeholder='Select spec'
      options={specList?.map((sp) => ({
        label: sp?.name,
        value: sp?.documentId
      }))}
    />;

  const Releases = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      placeholder='Select Tag / Release'
      options={releaseList?.map((rel) => ({
        label: rel?.name,
        value: rel?.releaseId
      }))}
    />;

  useEffect(() => {
    if (modules?.["data"]) {
      setModuleList(modules["data"]);
    }
  }, [modules?.["data"]]);

  const Module = ({ value, onChange }) => (
    <KoSelect
      placeholder="Select module"
      value={value}
      onChange={(v) => onChange(v)}
      options={moduleList?.map((module) => ({
        label: module?.name,
        value: module?.moduleId
      }))}
    />
  );
  

  const Components = ({ value, onChange }) =>
    <KoSelect
      placeholder='Select component'
      value={value}
      onChange={v => onChange(v)}
      showSearch
      options={componentsList?.map((comp) => ({
        label: comp?.name,
        value: comp?.componentId
      }))}
    />;

  const enabledButtons = {
    color: true,
    backgroundColor: true,
    alignLeft: true,
    alignCenter: true,
    alignRight: true,
    alignJustify: true,
    blockquote: true,
    codeBlock: true,
    link: true,
    insertEmbed: true
  };

  useEffect(()=>{
    if(initialValues?.lookupId){
      setLookupId(initialValues?.lookupId);
    }else{
      const lp = KoNano('LOK');
      setLookupId(lp);
      let data = form?.getFieldsValue();
      data['lookupId'] = lp;
      form.setFieldsValue({...data});
    }

  },[initialValues]);
  const AcceptanceCriteria = ({ value, onChange }) =>
    <KoRichTextEditor enabledButtons={enabledButtons} lookupId={lookupId} initialValues={value} onSetEditorValues={v => onChange(v)}/>;

  const Description = ({ value, onChange }) =>
    <KoRichTextEditor enabledButtons={enabledButtons} lookupId={lookupId}  initialValues={value} onSetEditorValues={v => onChange(v)}/>;

  const updateTicektInfo = (info) => {
    setRefresh(false);
    let data = form?.getFieldsValue();
    if(!initialValues?.ticketId){
      return;
    }
    const uniqueFiles = [...attachementsList, ...info].reduce((acc, file) => {
      const exists = acc.some(f => f.uid === file.uid);
      if (!exists) acc.push(file);
      return acc;
    }, []);

    data['attachments'] = uniqueFiles;
    form.setFieldsValue({ ...data });
    AssetsAPI.createOrUpdateIssues(data, initialValues?.ticketId, workspaceId).then(
      (data) => {
        setRefresh(true);
        // getTickets();
        setLoading(false);
        setUploadFileModal(false);
        dispatch(getTicketTabCount({ workspaceId: workspaceId, ticketId: initialValues?.ticketId }));
      },
      (err) => {
      }
    );
  };

  

  const props = {
    name: 'files',
    multiple: true,
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: { service: getCookie('wos'), module: 'taskplanner', lookupId: lookupId },
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },
  
    onChange(info) {
      setLoading(true);
      if (info.file.status !== 'uploading') {
      }
      const { fileList } = info;
  
      // Check if all uploads have either completed or failed
      const allFinished = fileList.every(
        file => file.status === 'done' || file.status === 'error'
      );
  
      if (allFinished) {
        setLoading(true);
  
        const successfulFiles = fileList
          .filter(file => file.status === 'done')
          .map(file => ({
            name: file.name,
            type: file.type,
            size: file.size,
            uid: file.uid,
            lastModifiedDate: file.lastModifiedDate || new Date().toISOString()
          }));
        updateTicektInfo(successfulFiles);
      }
      else if (info.file.status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }
  };
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };
  
  const updateAttachements=(attachments, info) => {
    setAttachementsList(attachments || []);
    if(info === 'rc'){
      updateTicektInfo(attachments);
    }
  };

  const onRemoveFile = (d) => {
    setRefresh(false);
    AssetsAPI.deleteAttachments(currentWorkspaceId, initialValues?.lookupId, d?.uid).then(
      (data) => {
        setRefresh(true);
        dispatch(getTicketTabCount({ workspaceId: currentWorkspaceId, ticketId: initialValues?.ticketId }));
      },
      (err) => {
      }
    );
  };

  const Sprint = ({ value, onChange }) =>{
    const sprints = useSelector(state => state?.sprints);
    return (
      <KoSelect value={value || undefined}
        onChange={v => onChange(v)}
        showSearch
        allowClear
        placeholder='Select sprint'
        options={sprints['data']?.map((spr) => ({
          label: spr?.name + `${spr?.status === 2 ? '  (active sprint)' : ''}`,
          value: spr?.sprintId
        }))}
      />
    );
  };


    
  const SUMMARYSECTION = {
    columns: 6,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'summary',
        placeholder: 'Enter asset summary or identifier',
        label: 'Asset Summary',
        colSpan: 3,
        rules: [{ required: true, message: 'Please enter asset summary.' }]
      },
      {
        key: 'issueType',
        label: 'Activity Type',
        colSpan: 1.5,
        widget: IssueType, // configured for Asset Management activity types
        disabled: initialValues?.issueType === 4,
        rules: [{ required: true, message: 'Please select activity type.' }]
      },
      {
        key: 'status',
        label: 'Asset Status',
        colSpan: 1.5,
        widget: TaskStatus,
        forwardRef: true
      },
      {
        key: 'lookupId',
        label: 'Asset ID / Tag',
        colSpan: 0,
        className: 'metaFieldHide'
      }
    ]
  };
  const BASICMETADATA = {
    columns: 6,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'label1s',
        colSpan: 64,
        render() {
          return (
            <fieldset>
              <div className={styles.createdAt}>
                <legend>ASSET DETAILS</legend>
              </div>
            </fieldset>
          );
        }
      },
      {
        key: 'priority',
        label: 'Asset Priority / Category',
        colSpan: 3,
        widget: Priority,
        forwardRef: true
      },
      {
        key: 'category',
        label: 'Asset Type',
        colSpan: 3,
        widget: Category // e.g. IT, Office Equipment, Infrastructure, Vehicle, etc.
      },
      {
        key: 'sla',
        label: 'Maintenance SLA (Days)',
        colSpan: 3
       // widget: SLATarget
      },
      {
        key: 'impact',
        label: 'Asset Value (₹)',
        colSpan: 3
       // widget: ImpactSelect
      },
      {
        key: 'label1',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend>ASSIGNMENT & OWNERSHIP</legend>
            </fieldset>
          );
        }
      },
      {
        key: 'assignee',
        label: 'Assigned To (User / Department)',
        colSpan: 3,
        widget: Assignees,
        forwardRef: true
      },
      {
        key: 'reporter',
        label: 'Registered By / Owner',
        colSpan: 3,
        widget: Reporter,
        rules: [{ required: true, message: 'Please select asset owner.' }]
      },
      {
        key: 'watchers',
        label: 'Supervisors / Monitors',
        colSpan: 3,
        widget: Watchers
      },
      {
        key: 'customerLink',
        label: 'Department / Cost Center',
        colSpan: 3,
        widget: Customers
      },
      {
        key: 'label3',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend>LIFECYCLE & TIMELINE</legend>
            </fieldset>
          );
        }
      },
      {
        key: 'isCalendar',
        colSpan: 6,
        label: '',
        widget: CheckBox
      },
      {
        key: 'startDate',
        placeholder: 'Procurement date',
        label: 'Start Date',
        colSpan: 3,
        widget: Date,
        rules: isCalendar ? [{ required: true, message: 'Please select procurement date.' }] : []
      },
      {
        key: 'endDate',
        placeholder: 'Expected disposal / renewal date',
        label: 'End Date',
        colSpan: 3,
        widget: Date,
        rules: isCalendar ? [{ required: true, message: 'Please select end date.' }] : []
      },
      {
        key: 'duration',
        placeholder: '0:00',
        label: 'Usage Duration',
        colSpan: 3,
        disabled: !isCalendar,
        widget: Duration
      },
      {
        key: 'slot',
        placeholder: 'Select maintenance slot',
        label: 'Maintenance Slot',
        colSpan: 3,
        disabled: !isCalendar,
        widget: StarTime
      },
      {
        key: 'label1a',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend>ADDITIONAL INFORMATION</legend>
            </fieldset>
          );
        }
      },
      {
        key: 'specLink',
        label: 'Asset Document / Warranty Link',
        colSpan: 3,
        widget: SpecLink
      },
      {
        key: 'release',
        label: 'Purchase Order / Vendor',
        colSpan: 3,
        widget: Releases
      },
      {
        key: 'module',
        label: 'Location / Site',
        colSpan: 3,
        widget: Module
      },
      {
        key: 'component',
        label: 'Asset Condition / Category',
        colSpan: 3,
        widget: Components
      }
    ]
  };
  const TASKINFOMETADATA = {
    columns: 6,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'acceptanceCriteria',
        placeholder: 'Add maintenance notes, service history, or disposal remarks',
        label: 'Maintenance / Audit Notes',
        colSpan: 6,
        widget: AcceptanceCriteria
      },
      {
        key: 'description',
        placeholder: 'Describe the asset, usage details, and condition summary',
        label: 'Asset Description',
        colSpan: 6,
        widget: Description
      }
    ]
  };






  const handleSubmit = useCallback(values => {
    values['lookupId'] = lookupId;
    handleFinish(values, epicId);
  });
  console.log(handleSubmit);

  return (
    <div className={`${styles.ticketWrapper} 'tabContnetTicket'`}>
      {isLoading && <KoLoader circle={false} />}
      <div className={`${styles.taskInfo} profileSection`}>
      </div>
      <div className={`${styles.wrapper}`}>
        <KoForm
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          onSubmit={handleSubmit}
        >
          <div className={styles.leftForm}>
            <KoFormBuilder form={form} meta={SUMMARYSECTION} />
            <div className={`${styles.taskInfo} profileSection`}>
            
              <KoTabs options={[
                {
                  label: <div className={styles.subTaskTab}>
                    {/* <KoIcon name='TextOutlined' width={14} height={14} /> */}
                    <KoText text={'Issue Details'} />
                  </div>,
                  children: <div className={styles.taskInfoTabs}>
                    <KoFormBuilder form={form} meta={TASKINFOMETADATA} /></div>,
                  key: 'about'
                },
                {
                  label: <div className={styles.subTaskTab}>
                    {/* <KoIcon name='AttachmentOutlined' width={14} height={14} /> */}
                    <KoBadge color="var(--palette-primary-main)" count={issueStates?.attachmentCount} offset={[9, 1]}>
                      <KoText text={'Attachments'} />
                    </KoBadge>
                  </div>,
                  children: <div className={`${styles.taskInfoTabs} tableCard`}>
                    <div className={`${styles.attachments}`}>
                      <KoTitle level={4} text={'Attachments'} />
                      <KoButton onClick={()=>setUploadFileModal(true)} color="purple" variant="outlined" className={'btn'} label={'Upload'} icon={<KoIcon color="#9154de" width={14} height={14} name={'AttachmentOutlined'} />} />
                    </div>
                    <Attachemnts refresh={refresh} setAttachementsList={updateAttachements} onRemoveFile={onRemoveFile} ticketId={initialValues?.ticketId} workspaceId={currentWorkspaceId} />
                  </div>,
                  key: 'attachments'
                },
                ...(!initialValues?.ticketId || initialValues?.issueType === 4 ?
                  [] : [{
                    label: <div className={styles.subTaskTab}>
                      {/* <KoIcon name='SubtaskOutlined' color="var(--palette-gray-7)" width={14} height={14} /> */}
                      <KoBadge color="var(--palette-primary-main)" count={issueStates?.subtaskCount} offset={[9, 1]}>
                        <KoText text={'Subtasks'} />
                      </KoBadge>
                      {/* {initialValues?.ticketId &&  <KoIcon name='PlusFilled' onClick={()=>setCreateSubTask(true)}/>} */}
                    </div>,
                    children: <SubTasksTable
                      issueType={IssueType}
                      Reporter={Reporter}
                      taskStatus={TaskStatus}
                      createSubTask={createSubTask}
                      workspace={workspace}
                      profile={profile}
                      openCreateSubTaskModal={setCreateSubTask}
                      priority={Priority}
                      date={Date}
                      sprint={Sprint}
                      assignees={Assignees}
                      TimeSpent={TimeSpent}
                      parentRecord={initialValues} />,
                    key: 'Subtasks',
                    disabled: (!initialValues?.ticketId || initialValues?.issueType === 4)
                  }]),
            
                {
                  label: <div className={styles.subTaskTab}>
                    {/* <KoIcon name='LogOutlined' width={13} height={13} /> */}
                    <KoBadge color="var(--palette-primary-main)" count={issueStates?.worklogCount} offset={[9, 1]}>
                      <KoText text={'Work Log'} />
                    </KoBadge>
                    {/* {initialValues?.ticketId &&  <KoIcon name='PlusFilled' onClick={()=>setCreateLog(true)}/>} */}
                  </div>,
                  children: <WorkLog LogList={initialValues?.workLog} workspaceIdFromParam={initialValues?.workspace} getIssueById={getIssueById} ticketId={initialValues?.ticketId} form={form} setCreateLog={setCreateLog} isCreateLogOpen={isCreateLogOpen} />,
                  key: 'worklog',
                  disabled: (!initialValues?.ticketId)
                },
                {
                  label: <div className={styles.subTaskTab}>
                    {/* <KoIcon name='ChatOutlined' width={15} height={15} color="var(--palette-gray-10)"/> */}
                    <KoBadge color="var(--palette-primary-main)" count={issueStates?.commentsCount} offset={[9, 1]}>
                      <KoText text={'Comments'} />
                    </KoBadge>
                    {/* {initialValues?.ticketId &&  <KoIcon name='PlusFilled' onClick={()=>setCreateComment(true)}/>} */}
                  </div>,
                  children: <div className={styles.worklogTab}>
                    <Comments workspaceId={initialValues?.workspace}
                      ticketId={initialValues?.ticketId}
                      setCreateComment={setCreateComment}
                      lookupId={lookupId}
                      isOpenCommentsModal={isOpenCommentsModal} />
                  </div>,
                  key: 'comments',
                  disabled: (!initialValues?.ticketId)
                }
            
                            // {
                            //   label: <div className={styles.subTaskTab}>
                            //     {/* <KoIcon name='InfoOutlined' width={15} height={15} color="var(--palette-gray-10)"/> */}
                            //     <KoBadge color="var(--palette-primary-main)" count={initialValues?.activitiesCount} offset={[9, 1]}>
                            //       <KoText text={'Activities'} />
                            //     </KoBadge>
                            //   </div>,
                            //   children: <div className={styles.taskInfoTabs}>
                            //     <Activities  workspaceId={initialValues?.workspace}
                            //       ticketId={initialValues?.ticketId}/>
                            //   </div>,
                            //   key: 'activities'
                            // }
            
              ]} />
            </div>
          </div>
          <div className={styles.rightForm}>
            <div className={styles.createdAtWrapperMain}>
              <div className={styles.createdAtWrapper}>
                <KoText text="Workspace" className={styles.createdAtText} />
                <KoTooltips title={"workspace Loading..."}>
                  <KoTag value={"workspace Loading..."} />
                </KoTooltips>
              </div>
              <div className={styles.createdAtWrapperDate}>
                {initialValues?.createdAt && (
                  <div className={styles.createdAtWrapper}>
                    <KoText
                      text="Created on"
                      className={styles.createdAtText}
                    />
                    <KoTag
                      iscount={false}
                      custom={true}
                      color="draft"
                      value={
                        <KoDateFormatter
                          className={styles.createdAtDate}
                          data={initialValues?.createdAt}
                          format="DD-MMM-YYYY"
                        />
                      }
                    />
                  </div>
                )}
                {initialValues?.updatedAt &&
                  initialValues?.updatedAt !== "0001-01-01T00:00:00Z" && (
                  <div className={styles.createdAtWrapper}>
                    <KoText
                      text="Last edited on"
                      className={styles.createdAtText}
                    />
                    <KoTag
                      iscount={false}
                      custom={true}
                      color="draft"
                      value={
                        <KoDateFormatter
                          className={styles.updatedAt}
                          data={initialValues?.updatedAt}
                          format="DD-MMM-YYYY"
                        />
                      }
                    />
                  </div>
                )}
              </div>
            </div>
            <KoFormBuilder form={form} meta={BASICMETADATA} />
          </div>
        </KoForm>
      </div>

      <KoModal
        title={'Upload File'}
        centered
        open={uploadFileModal}
        handleOk={() => { setUploadFileModal(false); }}
        onClose={() => { setUploadFileModal(false); }}
        width={760}
        footer={[]}
      >
        <div className={`${styles.uploadWrapper} customUpload`}>
          {isLoading && <KoLoader circle={false} />}
          <KoForm.Item
            name={["attachments"]}
            valuePropName={["attachments"]}
            getValueFromEvent={normFile}>
            <KoUpload
              isDnd={true}
              listType="picture"
              {...props}
            >
              <div className={styles.upload}>
                <p className="ant-upload-text">{`Click or drag file to this area to upload`} </p>
                <p className="ant-upload-hint">
                        Support for single or bulk uploads. Uploading banned files is strictly prohibited.
                </p>
              </div>
            </KoUpload>
          </KoForm.Item>
        </div>
      </KoModal>
    </div>
  );
}

export default Assets;
